import {
  Button,
  Container,
  Icon,
  SearchBox,
  Skeleton,
  Text,
  Notifications,
  Spinner,
  BadgeV2,
  AvatarV2,
  Tooltip,
  InputCheckbox,
  ActionButton,
  DropdownMenu,
  DropdownMenuGroup,
  DropdownMenuItem,
  Divider,
  Avatar,
  InputRadio,
} from "@jds/core";
import "./NewGuests.css";
import { Box, Chip, ImageList, Stack, Tab, Tabs } from "@mui/material";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import InviteGuestForm from "../components/UI/Form/InviteGuestForm";
import JdsModal from "../components/UI/JdsModal";
import AddButton from "../components/UI/Buttons/AddButton";
import UpdatedShareContainer from "../components/UI/Views/permission/UpdatedShareContainer";
import ApproveRegisteration from "../components/UI/Views/permission/ApproveRegisteration";
import EmptyState from "../components/NoData/EmptyState";
import GuestCard from "../components/UI/Cards/GuestCard";
import Loader from "../components/UI/Loader/Loader";
import useApiHttp from "../hooks/use-http";
import NewGuestCard from "../components/UI/Cards/NewGuestCard";
import ApprovedGuests from "../components/UI/Cards/GuestCards/ApprovedGuests";
import DeniedGuests from "../components/UI/Cards/GuestCards/DeniedGuests";
import BlockedGuests from "../components/UI/Cards/GuestCards/BlockedGuests";
import InvitedGuests from "../components/UI/Cards/GuestCards/InvitedGuests";
import RegisteredGuests from "../components/UI/Cards/GuestCards/RegisteredGuests";
import decryptUrl from "../util/img-decryption";
import EditGuestForm from "../components/UI/Form/EditGuestForm";
import GuestListModal from "../components/UI/GuestListModal";
import { NewGuestList } from "../components/UI/NewGuestList/NewGuestList";
import {
  addParamsURL,
  capitalizeWords,
  createWhatsAppLink,
  downloadQrImage,
  getLocalDate,
  getLocalTime,
} from "../util/helper";
import MuiPopover from "../components/UI/MuiPopover";
import { useSelector } from "react-redux";

const PROFILE_PICTURE_BACKEND_ENABLED = true;

const NewGuests = () => {
  const { id: eventId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const guestListRef = useRef();
  const [guestType, setGuestType] = useState(() => {
    if (location?.state?.registerGuest) {
      return "REGISTERED";
    } else {
      return "ALL";
    }
  });
  const [pageHeading, setPageHeading] = useState(() => {
    if (location?.state?.registerGuest) {
      return "Registered";
    } else {
      return "All";
    }
  });
  const [value, setValue] = useState("ALL"); //for Tabs
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [chipData, setChipData] = useState([]);
  const [editGuestData, setEditGuestData] = useState({});
  const [guestCount, setGuestCount] = useState(0);
  const [removeCount, setRemoveCount] = useState(0);
  const [guestList, setGuestList] = useState([]);
  const [userContactInfo, setUserContactInfo] = useState({});
  const [customFields, setCustomFields] = useState([]);
  const [customFieldAnalytics, setCustomFieldAnalytics] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [profilePictureFilter, setProfilePictureFilter] = useState(null);

  const [hasCustomField, setHasCustomField] = useState(false);
  const [gridView, setGridView] = useState(true);
  const [clearFileBlob, setClearFileBlob] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [dropValue, setDropValue] = useState();
  const [sortConfig, setSortConfig] = useState({
    sortBy: "createdAt",
    direction: "DESC",
  });
  //Modal useStates
  const [isAddGuestModalClose, setAddGuestModalClose] = useState(true);
  const [isProfileReminderModalClose, setProfileReminderModalClose] =
    useState(true);
  const [isApproveModalClose, setIsApproveModalClose] = useState(true);
  const [isContactInfoModalClose, setContactInfoModalClose] = useState(true);
  const [isRegisteredInfoModalClose, setRegisteredInfoModalClose] =
    useState(true);
  const [isBlockModalClose, setBlockModalClose] = useState(true);
  const [isDenyModalClose, setDenyModalClose] = useState(true);
  const [isEditGuestModalClosed, setIsEditGuestModalClose] = useState(true);
  const [isFaceModalClosed, setIsFaceModalClose] = useState(true);
  const [isSecondaryProfileModalClose, setSecondaryProfileModalClose] =
    useState(true);
  const [guestListTabs, setGuestListTabs] = useState([]);
  const [guestListDropDown, setGuestListDropDown] = useState({});
  const [eventDetails, setEventDetails] = useState();
  const [tableReset, setTableReset] = useState(false);
  const [refetchTable, setRefetchTable] = useState(false);
  const [secondaryProfileList, setSecondaryProfileList] = useState([]);
  const [reminderLoadingGuestId, setReminderLoadingGuestId] = useState(null);
  const { sendRequest: getGuestData, isLoading: guestDataLoading } =
    useApiHttp();
  const { sendRequest: getCustomFieldApi, isLoading: getCustomFielding } =
    useApiHttp();
  const { sendRequest: getAnalyticsCounts, isLoading: analyticsCountsLoading } =
    useApiHttp();
  const { sendRequest: getContactInfoApi, isLoading: contactInfoIsLoading } =
    useApiHttp();
  const loadDrawerContactInfo = useCallback((userId) => {
    setUserContactInfo({});
    getContactInfoApi(
      {
        url: `event-attendee/${eventId}/view-contact/${userId}`,
      },
      () => { },
      (data) => {
        setUserContactInfo(data?.data);
      },
    );
  }, [eventId, getContactInfoApi]);
  const { sendRequest: blockGuestApi, isLoading: blockGuestLoading } =
    useApiHttp();
  const { sendRequest: actionHandlerApi, isLoading: actionHandleLoading } =
    useApiHttp();
  const { sendRequest: restoreHandlerApi, isLoading: restoreHandleLoading } =
    useApiHttp();
  const { sendRequest: sendReminderApi } = useApiHttp();
  const {
    sendRequest: sendBlukReminderApi,
    isLoading: sendBlukReminderApiLoading,
  } = useApiHttp();
  const { sendRequest: getEventDetails, isLoading: eventDetailsLoading } =
    useApiHttp();
  const {
    sendRequest: getSecondaryProfiles,
    isLoading: secondaryProfilesLoading,
  } = useApiHttp();

  const apiGuestListType = {
    REGISTERED: "register",
    NULL: "invited",
    APPROVED: "approved",
    DENIED: "denied",
    ALL: "all",
    BLOCKED: "blocked",
    ATTENDING: "attending",
  };
  const pageHeadingObj = {
    REGISTERED: "Registered",
    NULL: "Invited",
    APPROVED: "Approved",
    DENIED: "Denied",
    ALL: "All",
    BLOCKED: "Blocked",
    ATTENDING: "Attending",
  };
  const guestTypesList = {
    ALL: "All Guests",
    ATTENDING: "Attending Guests",
    REGISTERED: "Registered Guests",
    NULL: "Invited Guests",
    APPROVED: "Approved Guests",
    DENIED: "Denied Guests",
    BLOCKED: "Blocked Guests",
  };
  const guestListTabs1 = [
    {
      label: "All Guests",
      value: "ALL",
    },
    {
      label: `Registered guests`,
      value: "REGISTERED",
    },
    {
      label: `Invited guests`,
      value: "NULL",
    },
    {
      label: `Approved guests`,
      value: "APPROVED",
    },
    {
      label: `Denied guests`,
      value: "DENIED",
    },
    {
      label: `Blocked guests`,
      value: "BLOCKED",
    },
  ];

  const handleClick = (guestType) => {
    setValue(guestType);
    setGuestType(guestType);
    setGuestList([]);
    setPage(0);
    setRemoveCount(0);
    setGuestCount(0);
    setSearchValue("");
  };
  const controller = new AbortController();
  // console.log("remove123", removeCount);
  const getGuestHandler = (type) => {
    setLoading(true);

    const body = {
      customFieldFilters: Object.entries(filterOptions).map(([key, value]) => ({
        id: key,
        value: value,
      })),
    };

    getGuestData(
      {
        url: `event-attendee/custom-filter/${type}/${eventId}/guests?page=${page}&size=10&sortBy=${sortConfig?.sortBy}&direction=${sortConfig?.direction}${searchValue ? `&nameQuery=${searchValue}` : ""}${PROFILE_PICTURE_BACKEND_ENABLED && profilePictureFilter !== null ? `&profilePictureFilter=${profilePictureFilter}` : ""
          }`,
        method: "POST",
        body: body,
        signal: controller.signal,
      },
      null,
      (data) => {
        setGuestCount(data?.count);
        setRemoveCount(0);
        if (page == 0) {
          setGuestList(data?.results || data?.data);
          setLastPage(data?.lastPage);
        } else {
          setGuestList((prev) =>
            data?.results
              ? [...prev, ...data?.results]
              : [...prev, ...data?.data],
          );
          setLastPage(data?.lastPage);
        }
        setClearFileBlob((pre) => !pre);
        setLoading(false);
      },
      (data) => {
        setLoading(false);
      },
    );
  };

  const actionHandler = (status, userId) => {
    actionHandlerApi(
      {
        url: "event-attendee/update-register-status",
        method: "POST",
        body: {
          eventId,
          userId,
          registerStatus: status,
        },
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "guest-action",
          title: data.message,
        });
        if (gridView) {
          if (guestType === "ALL") {
            if (status === "3") {
              setGuestList((pre) => {
                const updateData = pre.map((item) => {
                  if (item.id === userId) {
                    return {
                      ...item,
                      registerStatus: "DENIED",
                      isArchive: "true",
                    };
                  } else {
                    return item;
                  }
                });
                return updateData;
              });
            }
            if (status === "2") {
              setGuestList((pre) => {
                const updateData = pre.map((item) => {
                  if (item.id === userId) {
                    return {
                      ...item,
                      registerStatus: "APPROVED",
                    };
                  } else {
                    return item;
                  }
                });
                console.log("hello1234==>", updateData);

                return updateData;
              });
            }
            if (status === "1") {
              setGuestList((pre) => {
                const updateData = pre.map((item) => {
                  if (item.id === userId) {
                    return {
                      ...item,
                      registerStatus: "REGISTERED",
                      isArchive: "false",
                    };
                  } else {
                    return item;
                  }
                });
                return updateData;
              });
            }
          } else {
            setGuestList((pre) => {
              const updateData = pre.filter((item) => item.id !== userId);
              return updateData;
            });
            setRemoveCount((pre) => pre + 1);
          }
        } else {
          guestListRef.current.tableResetFun();
          setRemoveCount((pre) => pre + 1);

          // setTableReset((pre) => !pre);
        }
        setDenyModalClose(true);
      },
    );
  };

  const handleReminderCtaClick = (attendeeId) => {
    if (!PROFILE_PICTURE_BACKEND_ENABLED) return;

    setReminderLoadingGuestId(attendeeId);
    sendReminderApi(
      {
        url: `event-attendee/reminder/send/${eventId}`,
        method: "POST",
        body: {
          attendeeIds: [attendeeId],
        },
      },
      null,
      (data) => {
        setReminderLoadingGuestId(null);
        setGuestList((prev) =>
          prev.map((guest) =>
            guest?.id === attendeeId
              ? { ...guest, reminderCtaState: "PROCESSING" }
              : guest,
          ),
        );
        Notifications.toast.success({
          id: "guest-profile-reminder",
          title: data?.message || "Reminder sent successfully.",
        });
      },
      (err, data) => {
        setReminderLoadingGuestId(null);
        Notifications.toast.error({
          id: "guest-profile-reminder",
          title: data?.message || "Unable to send reminder.",
        });
      },
    );
  };

  const refreshCurrentGuestList = () => {
    if (gridView && page !== 0) {
      setGuestList([]);
      setPage(0);
      return;
    }

    if (gridView) {
      getGuestHandler(apiGuestListType[guestType]);
      return;
    }

    guestListRef.current?.tableResetFun();
  };

  const handleBulkReminder = () => {
    if (!PROFILE_PICTURE_BACKEND_ENABLED) return;

    sendBlukReminderApi(
      {
        url: `event-attendee/reminder/send-all/${eventId}`,
        method: "POST",
        body: null,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "bulk-guest-profile-reminder",
          title: data?.message || "Reminder sent successfully.",
        });
        refreshCurrentGuestList();
      },
      (err, data) => {
        Notifications.toast.error({
          id: "bulk-guest-profile-reminder",
          title: data?.message || "Unable to send reminder.",
        });
      },
    );
  };
  // Block Guest Api

  const handleBlock = (userId) => {
    blockGuestApi(
      {
        url: `event-attendee/delete`,
        method: "DELETE",
        body: {
          eventId: eventId,
          userId: userId,
        },
      },
      null,
      (res) => {
        Notifications.toast.success({
          id: "delete-guest",
          title: res?.message,
        });
        setBlockModalClose(true);
        if (gridView) {
          if (guestType === "ALL") {
            setGuestList((pre) => {
              const updateData = pre.map((item) => {
                if (item.id === userId) {
                  return {
                    ...item,
                    isBlocked: true,
                  };
                } else {
                  return item;
                }
              });
              return updateData;
            });
          } else {
            setGuestList((pre) => {
              const updateData = pre.filter((item) => item.id !== userId);
              return updateData;
            });
            setRemoveCount((pre) => pre + 1);
          }
        } else {
          guestListRef.current.tableResetFun();
          setRemoveCount((pre) => pre + 1);
        }
      },
      (err, data) => {
        Notifications.toast.error({
          id: "delete-guest",
          title: data?.message,
        });
      },
    );
  };
  const restoreHandler = (userId) => {
    // console.log("restore123hello");
    restoreHandlerApi(
      {
        url: "event-attendee/restore",
        method: "PUT",
        body: {
          eventId,
          userId,
        },
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "guest-restore",
          title: data.message,
        });
        if (gridView) {
          if (guestType === "ALL") {
            setGuestList((pre) => {
              const updateData = pre.map((item) => {
                if (item.id === userId) {
                  return {
                    ...item,
                    isBlocked: false,
                  };
                } else {
                  return item;
                }
              });
              return updateData;
            });
          } else {
            setGuestList((pre) => {
              const updateData = pre.filter((item) => item.id !== userId);
              return updateData;
            });
            setRemoveCount((pre) => pre + 1);
          }
        } else {
          guestListRef.current.tableResetFun();
          setRemoveCount((pre) => pre + 1);

          // setTableReset((pre) => !pre);
        }
      },
    );
  };

  const getCustomField = () => {
    getCustomFieldApi(
      {
        url: `event/${eventId}/custom_field`,
        method: "GET",
      },
      () => { },
      (data) => {
        const val = {};
        data?.data?.customField?.forEach((item) => {
          val[item.id] = item;
        });
        setHasCustomField(data?.data?.customField ? true : false);
        setCustomFields(val);
        console.log("custom data123", data?.data?.customField);
      },
    );
  };

  function handleGuestTypeEmptyState(guestType) {
    switch (guestType) {
      case "ATTENDING":
        return "No guests found! Invite guests to the event and share your moments";
      case "ALL":
        return "No guests found! Invite guests to the event and share your moments";
      case "REGISTERED":
        return "This page shows all the users who have registered through the QR code";
      case "NULL":
        return "This page shows the details of guests who were invited by the admin to the event.";
      case "APPROVED":
        return "This page shows the approved guest list from the registered users.";
      case "DENIED":
        return "This page shows the denied guests who were not approved by the admin from the registered users.";
      case "BLOCKED":
        return "This page shows the deleted guests who were previously part of the event and were deleted by the admin.";
      default:
        return "Unknown guest type";
    }
  }
  const handleDeleteChip = useCallback((id, label) => {
    setFilterOptions((prev) => {
      const newValues = prev[id].filter((item) => item !== label);
      if (newValues.length > 0) {
        return { ...prev, [id]: newValues };
      } else {
        const { [id]: _, ...rest } = prev;
        return rest;
      }
    });
  }, []);

  const handleDeleteProfilePictureChip = useCallback(() => {
    setProfilePictureFilter(null);
  }, []);

  const handleClearFilters = useCallback(() => {
    setFilterOptions({});
    setProfilePictureFilter(null);
  }, []);

  const guestCommonCoulmn = [
    {
      field: "s_no",
      headerName: "S.No",
      width: 70,
      sortable: false,
    },

    {
      field: "profile",
      headerName: "Profile",
      width: 80,
      sortable: false,
      renderCell: (params) => {
        const profilePic = params?.row?.profilePictureThumbnailUrl
          ? params?.row?.profilePictureThumbnailUrl
          : null;
        if (params?.row?.isBlocked) {
          return (
            <div
              style={{
                filter: "grayscale(1)",
              }}>
              <AvatarV2
                avatarKind={profilePic ? "image" : "icon"}
                image={
                  profilePic ? addParamsURL(profilePic, { size: "s" }) : ""
                }
                onClick={
                  params?.row?.profilePictureThumbnailUrl
                    ? () => {
                      setEditGuestData(params.row);
                      // setIsFaceModalClose(false);
                      navigate(
                        `/home/events/guests/${eventId}/guest-cluster-list/${params?.row?.userId}`,
                        {
                          state: {
                            firstName: params?.row?.firstName,
                            lastName: params?.row?.lastName,
                            indexedProfileThumbnail:
                              params?.row?.profilePictureThumbnailUrl,
                            indexedProfilePic: params?.row?.profilePictureUrl,
                            secondaryProfilesCount:
                              params?.row?.secondaryProfilesCount,
                          },
                        },
                      );
                    }
                    : undefined
                }
              />
            </div>
          );
        } else {
          return (
            <AvatarV2
              avatarKind={profilePic ? "image" : "icon"}
              image={profilePic ? addParamsURL(profilePic, { size: "s" }) : ""}
              onClick={
                params?.row?.profilePictureThumbnailUrl
                  ? () => {
                    setEditGuestData(params.row);
                    // setIsFaceModalClose(false);
                    navigate(
                      `/home/events/guests/${eventId}/guest-cluster-list/${params?.row?.userId}`,
                      {
                        state: {
                          firstName: params?.row?.firstName,
                          lastName: params?.row?.lastName,
                          indexedProfileThumbnail:
                            params?.row?.profilePictureThumbnailUrl,
                          indexedProfilePic: params?.row?.profilePictureUrl,
                          secondaryProfilesCount:
                            params?.row?.secondaryProfilesCount,
                        },
                      },
                    );
                  }
                  : undefined
              }
            />
          );
        }
      },
    },
    {
      field: "fullName",
      headerName: "Name",
      width: 150,
      sortable: true,
      renderCell: (params) =>
        `${params?.row?.firstName || "User"} ${params?.row?.lastName || ""}`,
    },
    {
      field: "email",
      headerName: "Email Id",
      width: 140,
      sortable: false,
      renderCell: (params) => `${params?.row?.email || "-"}`,
    },
    {
      field: "phone",
      headerName: "Phone Number",
      width: 150,
      sortable: false,
      renderCell: (params) =>
        `${params?.row?.countryCode}-${params?.row?.phoneNumber}`,
    },
  ];
  const guestListCoulmn = {
    REGISTERED: [
      ...guestCommonCoulmn,
      {
        field: "createdAt",
        headerName: "Registered date",
        width: 160,
        sortable: true,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalDate(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "registered-time",
        headerName: "Registered time",
        width: 160,
        sortable: false,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalTime(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action",
        headerName: "Action",
        width: 170,
        sortable: false,
        renderCell: (params) => {
          return (
            <Container gap={10} verticalAlign="center">
              {/* <Button
                label="Approve"
                kind="secondary"
                size="small"
                onClick={() => actionHandler("2", params.row.id)}
              /> */}
              <Tooltip position="bottom" label="Approve">
                <Icon
                  ic={"IcSuccessColored"}
                  onClick={() => actionHandler("2", params?.row?.id)}
                />
              </Tooltip>
              {hasCustomField && (
                <Tooltip position="bottom" label="Registered Information">
                  <Icon
                    ic={"IcForm"}
                    color="primary_grey_80"
                    onClick={() => {
                      setRegisteredInfoModalClose(false);
                      setEditGuestData(params?.row);
                    }}
                  />
                </Tooltip>
              )}
              {/* <Button
                label="Deny"
                kind="secondary"
                size="small"
                state="destructive"
                onClick={() => {
                  setEditGuestData(params.row);
                  setDenyModalClose(false);
                }}
              /> */}
              <Tooltip position="bottom" label="Deny">
                <Icon
                  ic={"IcBlocked"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setDenyModalClose(false);
                  }}
                  color="feedback_error_50"
                />
              </Tooltip>
              <Tooltip position="bottom" label="Block">
                <Icon
                  ic={"IcBlocked"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setBlockModalClose(false);
                  }}
                />
              </Tooltip>
              {/* <Tooltip position="bottom" label="Edit">
                <Icon
                  ic={"IcEdit"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setIsEditGuestModalClose(false);
                  }}
                />
              </Tooltip> */}
              <Tooltip position="bottom" label="Contact Information">
                <Icon
                  ic={"IcContactUs"}
                  onClick={() => {
                    getContactInfoApi(
                      {
                        url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                      },
                      () => { },
                      (data) => {
                        setUserContactInfo(data?.data);
                      },
                    );
                    setContactInfoModalClose(false);
                  }}
                />
              </Tooltip>
            </Container>
          );
        },
      },
    ],
    NULL: [
      ...guestCommonCoulmn,
      {
        field: "image_access",
        headerName: "Image Access",
        width: 140,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label={
                params?.row?.access
                  ? capitalizeWords(params?.row?.access, "_")
                  : "No Access"
              }
              icon="IcPhoto"
              size="large"
              backgroundInfoColor="var(--color-primary-50)"
            />
          </Container>
        ),
      },
      {
        field: "upload_access",
        headerName: "Upload Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Upload Access"
              icon={
                params?.row?.uploadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.uploadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "download_access",
        headerName: "Download Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Download Access"
              icon={
                params?.row?.downloadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.downloadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "createdAt",
        headerName: "Invited date",
        width: 120,
        sortable: true,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalDate(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "invited-time",
        headerName: "Invited time",
        width: 120,
        sortable: false,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalTime(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action",
        headerName: "Action",
        width: 80,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            {params?.row?.userId ? (
              <Tooltip position="bottom" label="Block">
                <Icon
                  ic={"IcBlocked"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setBlockModalClose(false);
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip position="bottom" label="Edit">
                <Icon
                  ic={"IcEdit"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setIsEditGuestModalClose(false);
                  }}
                />
              </Tooltip>
            )}

            {hasCustomField && (
              <Tooltip position="bottom" label="Registered Information">
                <Icon
                  ic={"IcForm"}
                  color="primary_grey_80"
                  onClick={() => {
                    setRegisteredInfoModalClose(false);
                    setEditGuestData(params?.row);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip position="bottom" label="Contact Information">
              <Icon
                ic={"IcContactUs"}
                onClick={() => {
                  getContactInfoApi(
                    {
                      url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                    },
                    () => { },
                    (data) => {
                      setUserContactInfo(data?.data);
                    },
                  );
                  setContactInfoModalClose(false);
                }}
              />
            </Tooltip>
          </Container>
        ),
      },
    ],
    APPROVED: [
      ...guestCommonCoulmn,
      {
        field: "image_access",
        headerName: "Image Access",
        width: 140,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label={
                params?.row?.access
                  ? capitalizeWords(params?.row?.access, "_")
                  : "No Access"
              }
              icon="IcPhoto"
              size="large"
              backgroundInfoColor="var(--color-primary-50)"
            />
          </Container>
        ),
      },
      {
        field: "upload_access",
        headerName: "Upload Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Upload Access"
              icon={
                params?.row?.uploadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.uploadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "download_access",
        headerName: "Download Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Download Access"
              icon={
                params?.row?.downloadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.downloadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "createdAt",
        headerName: "Registered date",
        width: 120,
        sortable: true,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalDate(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "registered-time",
        headerName: "Registered time",
        width: 120,
        sortable: false,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalTime(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action",
        headerName: "Action",
        width: 80,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <Tooltip position="bottom" label="Block">
              <Icon
                ic={"IcBlocked"}
                onClick={() => {
                  setEditGuestData(params?.row);
                  setBlockModalClose(false);
                }}
              />
            </Tooltip>
            {hasCustomField && (
              <Tooltip position="bottom" label="Registered Information">
                <Icon
                  ic={"IcForm"}
                  color="primary_grey_80"
                  onClick={() => {
                    setRegisteredInfoModalClose(false);
                    setEditGuestData(params?.row);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip position="bottom" label="Contact Information">
              <Icon
                ic={"IcContactUs"}
                onClick={() => {
                  getContactInfoApi(
                    {
                      url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                    },
                    () => { },
                    (data) => {
                      setUserContactInfo(data?.data);
                    },
                  );
                  setContactInfoModalClose(false);
                }}
              />
            </Tooltip>
          </Container>
        ),
      },
    ],
    DENIED: [
      ...guestCommonCoulmn,
      {
        field: "action",
        headerName: "Action",
        width: 80,
        sortable: false,
        renderCell: (params) => (
          <>
            {/* <Button
              // iconLeft={<img src={resetIcon} alt="grid icon" />}
              // iconLeft={"IcReset"}
              label="Restore"
              kind="secondary"
              size="small"
              fullWidth
              onClick={() => actionHandler("1", params.row.id)}
            /> */}
            <Tooltip position="bottom" label="Restore">
              <Icon
                ic={"IcReset"}
                onClick={() => actionHandler("1", params?.row?.id)}
              />
            </Tooltip>
            {hasCustomField && (
              <Tooltip position="bottom" label="Registered Information">
                <Icon
                  ic={"IcForm"}
                  color="primary_grey_80"
                  onClick={() => {
                    setRegisteredInfoModalClose(false);
                    setEditGuestData(params?.row);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip position="bottom" label="Contact Information">
              <Icon
                ic={"IcContactUs"}
                onClick={() => {
                  getContactInfoApi(
                    {
                      url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                    },
                    () => { },
                    (data) => {
                      setUserContactInfo(data?.data);
                    },
                  );
                  setContactInfoModalClose(false);
                }}
              />
            </Tooltip>
          </>
        ),
      },
    ],
    ATTENDING: [
      ...guestCommonCoulmn,
      {
        field: "image_access",
        headerName: "Image Access",
        width: 140,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label={
                params?.row?.access
                  ? capitalizeWords(params?.row?.access, "_")
                  : "No Access"
              }
              icon="IcPhoto"
              size="large"
              backgroundInfoColor="var(--color-primary-50)"
            />
          </Container>
        ),
      },
      {
        field: "upload_access",
        headerName: "Upload Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Upload Access"
              icon={
                params?.row?.uploadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.uploadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "download_access",
        headerName: "Download Access",
        width: 180,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            <BadgeV2
              label="Download Access"
              icon={
                params?.row?.downloadAccess == "APPROVED"
                  ? "IcSuccess"
                  : "IcError"
              }
              size="large"
              backgroundInfoColor={
                params?.row?.downloadAccess == "APPROVED"
                  ? "var(--color-feedback-success-50)"
                  : "var(--color-feedback-error-50)"
              }
            />
          </Container>
        ),
      },
      {
        field: "createdAt",
        headerName: "Date",
        width: 120,
        sortable: true,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalDate(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action-time",
        headerName: "Time",
        width: 120,
        sortable: false,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalTime(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action",
        headerName: "Action",
        width: 100,
        sortable: false,
        renderCell: (params) => (
          <Container gap={10} verticalAlign="center">
            {params?.row?.userId ? (
              <Tooltip position="bottom" label="Block">
                <Icon
                  ic={"IcBlocked"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setBlockModalClose(false);
                  }}
                />
              </Tooltip>
            ) : (
              <Tooltip position="bottom" label="Edit">
                <Icon
                  ic={"IcEdit"}
                  onClick={() => {
                    setEditGuestData(params?.row);
                    setIsEditGuestModalClose(false);
                  }}
                />
              </Tooltip>
            )}
            {hasCustomField && (
              <Tooltip position="bottom" label="Registered Information">
                <Icon
                  ic={"IcForm"}
                  color="primary_grey_80"
                  onClick={() => {
                    setRegisteredInfoModalClose(false);
                    setEditGuestData(params?.row);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip position="bottom" label="Contact Information">
              <Icon
                ic={"IcContactUs"}
                onClick={() => {
                  getContactInfoApi(
                    {
                      url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                    },
                    () => { },
                    (data) => {
                      setUserContactInfo(data?.data);
                    },
                  );
                  setContactInfoModalClose(false);
                }}
              />
            </Tooltip>
          </Container>
        ),
      },
    ],
    ALL: [
      ...guestCommonCoulmn,
      {
        field: "image_access",
        headerName: "Image Access",
        width: 140,
        sortable: false,
        renderCell: (params) =>
          params?.row?.isBlocked ||
            params?.row?.registerStatus == "REGISTERED" ||
            params?.row?.registerStatus == "DENIED" ? (
            "-"
          ) : (
            <Container gap={10} verticalAlign="center">
              <BadgeV2
                label={
                  params?.row?.access
                    ? capitalizeWords(params?.row?.access, "_")
                    : "No Access"
                }
                icon="IcPhoto"
                size="large"
                backgroundInfoColor="var(--color-primary-50)"
              />
            </Container>
          ),
      },
      {
        field: "upload_access",
        headerName: "Upload Access",
        width: 180,
        sortable: false,
        renderCell: (params) =>
          params?.row?.isBlocked ||
            params?.row?.registerStatus == "REGISTERED" ||
            params?.row?.registerStatus == "DENIED" ? (
            "-"
          ) : (
            <Container gap={10} verticalAlign="center">
              <BadgeV2
                label="Upload Access"
                icon={
                  params?.row?.uploadAccess == "APPROVED"
                    ? "IcSuccess"
                    : "IcError"
                }
                size="large"
                backgroundInfoColor={
                  params?.row?.uploadAccess == "APPROVED"
                    ? "var(--color-feedback-success-50)"
                    : "var(--color-feedback-error-50)"
                }
              />
            </Container>
          ),
      },
      {
        field: "download_access",
        headerName: "Download Access",
        width: 180,
        sortable: false,
        renderCell: (params) =>
          params?.row?.isBlocked ||
            params?.row?.registerStatus == "REGISTERED" ||
            params?.row?.registerStatus == "DENIED" ? (
            "-"
          ) : (
            <Container gap={10} verticalAlign="center">
              <BadgeV2
                label="Download Access"
                icon={
                  params?.row?.downloadAccess == "APPROVED"
                    ? "IcSuccess"
                    : "IcError"
                }
                size="large"
                backgroundInfoColor={
                  params?.row?.downloadAccess == "APPROVED"
                    ? "var(--color-feedback-success-50)"
                    : "var(--color-feedback-error-50)"
                }
              />
            </Container>
          ),
      },
      {
        field: "createdAt",
        headerName: "Date",
        width: 120,
        sortable: true,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalDate(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action-time",
        headerName: "Time",
        width: 120,
        sortable: false,
        renderCell: (params) =>
          `${(params?.row?.createdAt && getLocalTime(params?.row?.createdAt)) ||
          "-"
          }`,
      },
      {
        field: "action",
        headerName: "Action",
        width: 170,
        sortable: false,
        renderCell: (params) => {
          if (params?.row?.isBlocked) {
            return (
              <>
                {/* <Button
              // iconLeft={<img src={resetIcon} alt="grid icon" />}
              // iconLeft={"IcReset"}
              label="Restore"
              kind="secondary"
              size="small"
              fullWidth
              onClick={() => restoreHandler(params.row.id)}
            /> */}
                <Tooltip position="bottom" label="Unblock">
                  <Icon
                    ic={"IcReset"}
                    onClick={() => restoreHandler(params?.row?.id)}
                  />
                </Tooltip>
                {hasCustomField && (
                  <Tooltip position="bottom" label="Registered Information">
                    <Icon
                      ic={"IcForm"}
                      color="primary_grey_80"
                      onClick={() => {
                        setRegisteredInfoModalClose(false);
                        setEditGuestData(params?.row);
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip position="bottom" label="Contact Information">
                  <Icon
                    ic={"IcContactUs"}
                    onClick={() => {
                      getContactInfoApi(
                        {
                          url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                        },
                        () => { },
                        (data) => {
                          setUserContactInfo(data?.data);
                        },
                      );
                      setContactInfoModalClose(false);
                    }}
                  />
                </Tooltip>
              </>
            );
          }
          if (params?.row?.registerStatus == "REGISTERED") {
            return (
              <Container gap={10} verticalAlign="center">
                {/* <Button
                  label="Approve"
                  kind="secondary"
                  size="small"
                  onClick={() => actionHandler("2", params.row.id)}
                /> */}
                <Tooltip position="bottom" label="Approve">
                  <Icon
                    ic={"IcSuccessColored"}
                    onClick={() => actionHandler("2", params?.row?.id)}
                  />
                </Tooltip>
                {hasCustomField && (
                  <Tooltip position="bottom" label="Registered Information">
                    <Icon
                      ic={"IcForm"}
                      color="primary_grey_80"
                      onClick={() => {
                        setRegisteredInfoModalClose(false);
                        setEditGuestData(params?.row);
                      }}
                    />
                  </Tooltip>
                )}
                {/* <Button
                  label="Deny"
                  kind="secondary"
                  size="small"
                  state="destructive"
                  onClick={() => {
                    setEditGuestData(params.row);
                    setDenyModalClose(false);
                  }}
                /> */}
                <Tooltip position="bottom" label="Deny">
                  <Icon
                    ic={"IcBlocked"}
                    onClick={() => {
                      setEditGuestData(params?.row);
                      setDenyModalClose(false);
                    }}
                    color="feedback_error_50"
                  />
                </Tooltip>
                <Tooltip position="bottom" label="Block">
                  <Icon
                    ic={"IcBlocked"}
                    onClick={() => {
                      setEditGuestData(params?.row);
                      setBlockModalClose(false);
                    }}
                  />
                </Tooltip>
                <Tooltip position="bottom" label="Contact Information">
                  <Icon
                    ic={"IcContactUs"}
                    onClick={() => {
                      getContactInfoApi(
                        {
                          url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                        },
                        () => { },
                        (data) => {
                          setUserContactInfo(data?.data);
                        },
                      );
                      setContactInfoModalClose(false);
                    }}
                  />
                </Tooltip>
              </Container>
            );
          }
          if (params?.row?.registerStatus == "DENIED") {
            return (
              <>
                {/* <Button
              // iconLeft={<img src={resetIcon} alt="grid icon" />}
              // iconLeft={"IcReset"}
              label="Restore"
              kind="secondary"
              size="small"
              fullWidth
              onClick={() => actionHandler("1", params.row.id)}
            /> */}
                <Tooltip position="bottom" label="Restore">
                  <Icon
                    ic={"IcReset"}
                    onClick={() => actionHandler("1", params?.row?.id)}
                  />
                </Tooltip>
                {hasCustomField && (
                  <Tooltip position="bottom" label="Registered Information">
                    <Icon
                      ic={"IcForm"}
                      color="primary_grey_80"
                      onClick={() => {
                        setRegisteredInfoModalClose(false);
                        setEditGuestData(params?.row);
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip position="bottom" label="Contact Information">
                  <Icon
                    ic={"IcContactUs"}
                    onClick={() => {
                      getContactInfoApi(
                        {
                          url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                        },
                        () => { },
                        (data) => {
                          setUserContactInfo(data?.data);
                        },
                      );
                      setContactInfoModalClose(false);
                    }}
                  />
                </Tooltip>
              </>
            );
          }
          if (
            params?.row?.registerStatus == "APPROVED" ||
            params?.row?.registerStatus == null
          ) {
            return (
              <Container gap={10} verticalAlign="center">
                {params?.row?.userId ? (
                  <Tooltip position="bottom" label="Block">
                    <Icon
                      ic={"IcBlocked"}
                      onClick={() => {
                        setEditGuestData(params?.row);
                        setBlockModalClose(false);
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip position="bottom" label="Edit">
                    <Icon
                      ic={"IcEdit"}
                      onClick={() => {
                        setEditGuestData(params?.row);
                        setIsEditGuestModalClose(false);
                      }}
                    />
                  </Tooltip>
                )}

                {hasCustomField && (
                  <Tooltip position="bottom" label="Registered Information">
                    <Icon
                      ic={"IcForm"}
                      color="primary_grey_80"
                      onClick={() => {
                        setRegisteredInfoModalClose(false);
                        setEditGuestData(params?.row);
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip position="bottom" label="Contact Information">
                  <Icon
                    ic={"IcContactUs"}
                    onClick={() => {
                      getContactInfoApi(
                        {
                          url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                        },
                        () => { },
                        (data) => {
                          setUserContactInfo(data?.data);
                        },
                      );
                      setContactInfoModalClose(false);
                    }}
                  />
                </Tooltip>
              </Container>
            );
          }
        },
      },
    ],
    BLOCKED: [
      ...guestCommonCoulmn,
      {
        field: "action",
        headerName: "Action",
        width: 80,
        sortable: false,
        renderCell: (params) => (
          <>
            {/* <Button
              // iconLeft={<img src={resetIcon} alt="grid icon" />}
              // iconLeft={"IcReset"}
              label="Restore"
              kind="secondary"
              size="small"
              fullWidth
              onClick={() => restoreHandler(params.row.id)}
            /> */}
            <Tooltip position="bottom" label="Unblock">
              <Icon
                ic={"IcReset"}
                onClick={() => restoreHandler(params?.row?.id)}
              />
            </Tooltip>
            {hasCustomField && (
              <Tooltip position="bottom" label="Registered Information">
                <Icon
                  ic={"IcForm"}
                  color="primary_grey_80"
                  onClick={() => {
                    setRegisteredInfoModalClose(false);
                    setEditGuestData(params?.row);
                  }}
                />
              </Tooltip>
            )}
            <Tooltip position="bottom" label="Contact Information">
              <Icon
                ic={"IcContactUs"}
                onClick={() => {
                  getContactInfoApi(
                    {
                      url: `event-attendee/${eventId}/view-contact/${params?.row?.id}`,
                    },
                    () => { },
                    (data) => {
                      setUserContactInfo(data?.data);
                    },
                  );
                  setContactInfoModalClose(false);
                }}
              />
            </Tooltip>
          </>
        ),
      },
    ],
  };
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (guestDataLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [guestDataLoading, lastPage],
  );

  useEffect(() => {
    setPageHeading(pageHeadingObj[guestType]);
    getGuestHandler(apiGuestListType[guestType]);

    return () => {
      controller.abort();
    };
  }, [page, guestType, searchValue, filterOptions, sortConfig, profilePictureFilter]);

  useEffect(() => {
    if (location?.state?.addGuest) {
      setAddGuestModalClose(false);
    }
    getCustomField();
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        setEventDetails(data?.data);
        if (data?.data?.isAutoApproval) {
          setGuestListTabs([
            {
              label: "All Guests",
              value: "ALL",
            },
            { label: "Attending Guests", value: "ATTENDING" },

            {
              label: `Invited guests`,
              value: "NULL",
            },
            {
              label: `Approved guests`,
              value: "APPROVED",
            },
            {
              label: `Blocked guests`,
              value: "BLOCKED",
            },
          ]);
          setGuestListDropDown({
            ALL: "All Guests",
            ATTENDING: "Attending Guests",
            NULL: "Invited Guests",
            APPROVED: "Approved Guests",
            BLOCKED: "Blocked Guests",
          });
        } else {
          setGuestListTabs([
            {
              label: "All Guests",
              value: "ALL",
            },
            { label: "Attending Guests", value: "ATTENDING" },

            {
              label: `Registered guests`,
              value: "REGISTERED",
            },
            {
              label: `Invited guests`,
              value: "NULL",
            },
            {
              label: `Approved guests`,
              value: "APPROVED",
            },
            {
              label: `Denied guests`,
              value: "DENIED",
            },
            {
              label: `Blocked guests`,
              value: "BLOCKED",
            },
          ]);
          setGuestListDropDown({
            ALL: "All Guests",
            ATTENDING: "Attending Guests",
            REGISTERED: "Registered Guests",
            NULL: "Invited Guests",
            APPROVED: "Approved Guests",
            DENIED: "Denied Guests",
            BLOCKED: "Blocked Guests",
          });
        }
      },
      (err, data) => { },
    );
    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/custom-field/${eventId}`,
      },
      null,
      (data) => {
        setCustomFieldAnalytics(data?.data);
        // const filterOptions = {};
        // data?.data?.forEach((field) => {
        //   filterOptions[field.id] = [];
        // });

        // setFilterOptions(filterOptions);
      },
      (err, data) => {
        // console.log('Custom field data', data)
      },
    );
  }, []);
  useEffect(() => {
    setGridView(
      searchParams.get("gridView") === "true" || !searchParams.get("gridView"),
    );
  }, [searchParams]);
  // console.log("hello123loading", guestDataLoading);

  if (eventDetailsLoading) {
    return (
      <Container
        fullWidth
        horizontalAlign="center"
        verticalAlign="center"
        style={{ minHeight: "220px" }}>
        <Spinner kind="primary" label="Loading..." size="large" />
      </Container>
    );
  }
  return (
    <>
      <Container
        fullWidth
        direction="column"
        style={{
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          padding: "32px 16px 0px 16px",
          zIndex: 30,
          width: "calc(100% + 32px)",
          alignItems: "center",
          marginLeft: "-16px",
        }}>
        <Tabs
          className="guestType-tabs"
          value={guestType}
          onChange={(e, val) => {
            handleClick(val);
          }}
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={{
            backgroundColor: "rgb(229 241 247 / 40%)",
            borderRadius: "24px",
            width: "100%",
            maxWidth: "100%", // Ensure tabs don't overflow the screen
            overflowX: "auto", // Allow horizontal scroll
            "& .css-1w95tg6-MuiTabs-indicator": {
              height: "46px !important",
              borderRadius: "32px",
            },
          }}>
          {guestListTabs.map((item) => (
            <Tab
              key={item.value}
              label={
                <Text
                  text={item?.label}
                  // color={value === item?.value ? "white" : "primary-60"}
                  color={"primary-60"}
                  appearance="body-xs-bold"
                />
              }
              value={item.value}
              sx={{
                margin: "0 15px",
                minWidth: "100px",
                width: "auto",
                flex: eventDetails?.isAutoApproval ? 1 : "none",
                zIndex: 1,
                backgroundColor:
                  value === item?.value ? "primary-60" : "transparent",
                borderRadius: "12px",
                transition: "background-color 0.3s ease",
              }}
            />
          ))}
        </Tabs>
        <Container
          fullWidth
          horizontalAlign="space-between"
          style={{ marginTop: "38px" }}
          className="guest-container-wrapper">
          <Container direction="column" gap={8}>
            <Text text={`${pageHeading} Guests`} appearance="heading_xs" />
            <Text
              text={`Guests - ${guestCount - removeCount}`}
              color="primary_grey_80"
              appearance="body-m-bold"
            />
          </Container>
          <Container
            direction="row"
            horizontalAlign="right"
            verticalAlign="center"
            gap={16}
            className="guest-container-wrapper">
            <Tooltip label="Click here to invite guest" position="bottom">
              {" "}
              <Box
                sx={{
                  "& .j-JDSButton-jds-text": {
                    textWrap: "nowrap",
                    whiteSpace: "nowrap",
                  },
                }}>
                <AddButton
                  kind="primary"
                  label="Invite Guest"
                  size="small"
                  onClick={() => {
                    setAddGuestModalClose(false);
                  }}
                />
              </Box>
            </Tooltip>

            <Box
              sx={{
                "& .j-JDSButton-jds-text": {
                  textWrap: "nowrap",
                  whiteSpace: "nowrap",
                },
              }}>
              <Container
                gap={16}
                verticalAlign="center"
                className="guest-container-wrapper">
                {/* {guestType === "REGISTERED" && (
                  <Button
                    kind="secondary"
                    label="Update Status"
                    size="small"
                    onClick={() => setIsApproveModalClose(false)}
                  />
                )} */}
                <Box
                  sx={{
                    "& .j-JDSButton-jds-text": {
                      textWrap: "nowrap",
                      whiteSpace: "nowrap",
                    },
                  }}>
                  <Button
                    kind="secondary"
                    iconLeft={"IcShare"}
                    label="Share Photos"
                    size="small"
                    onClick={() => {
                      navigate(`/home/events/share/${eventId}`);
                      // setShareModalClose(false);
                    }}
                  />
                </Box>
                {PROFILE_PICTURE_BACKEND_ENABLED && (
                  <Box
                    sx={{
                      "& .j-JDSButton-jds-text": {
                        textWrap: "nowrap",
                        whiteSpace: "nowrap",
                      },
                    }}>
                    <Button
                      kind="secondary"
                      iconLeft={"IcSendMessage"}
                      label="Request Profile Picture"
                      size="small"
                      onClick={() => {
                        setProfileReminderModalClose(false);
                      }}
                    />
                  </Box>
                )}
              </Container>
            </Box>
            <Tooltip
              label={`${gridView ? "List View" : "Grid View"}`}
              position="bottom">
              <span
                onClick={() => {
                  if (!gridView) {
                    if (page !== 0) {
                      setPage(0);
                    } else {
                      getGuestHandler(apiGuestListType[guestType]);
                    }
                  }
                  setSearchParams({
                    gridView: !gridView,
                  });
                }}
                style={{ cursor: "pointer" }}>
                <Icon ic={gridView ? "IcList" : "IcAssistiveGrid"} />
              </span>
            </Tooltip>
            {gridView ? (
              <MuiPopover
                trigger={{
                  component: SortBtn,
                }}
                sx={{
                  padding: 0,
                  maxWidth: "250px",
                  width: "100%",
                  borderRadius: "8px",
                  // backgroundColor: "blue",
                }}>
                <SortComponent
                  sortConfig={sortConfig}
                  setSortConfig={setSortConfig}
                  setPage={setPage}
                />
              </MuiPopover>
            ) : (
              <></>
            )}

            <MuiPopover
              trigger={{
                component: FilterBtn,
              }}
              sx={{
                padding: 0,
                maxWidth: "250px",
                width: "100%",
                borderRadius: "8px",
              }}>
              <FilterComponent
                customFieldAnalytics={customFieldAnalytics}
                filterOptions={filterOptions}
                setFilterOptions={setFilterOptions}
                setPage={setPage}
                profilePictureFilter={
                  PROFILE_PICTURE_BACKEND_ENABLED ? profilePictureFilter : null
                }
                setProfilePictureFilter={
                  PROFILE_PICTURE_BACKEND_ENABLED
                    ? setProfilePictureFilter
                    : () => { }
                }
              />
            </MuiPopover>

            <SearchBox
              value={searchValue}
              onChange={(e) => {
                setGuestList([]);
                const searchValue = e.target.value;
                setSearchValue(searchValue);
                setPage(0);
              }}
              label="Search Guests"
              prefix="IcSearch"
            />
            <div
              style={{ position: "relative" }}
              className="guest-type-dropdown">
              <ActionButton
                kind="primary"
                label={dropValue || "All Guests"}
                icon="IcChevronDown"
                size="medium"
                iconPosition="right"
                onClick={() => {
                  setOpenDropdown(true);
                }}
              />
              <div
                className="drop"
              // style={{
              //   position: "absolute !important",
              //   top: "38dvh !important",
              //   left: "23dvw !important",
              // }}
              >
                <DropdownMenu
                  className="drop"
                  open={openDropdown}
                  position="bottom-start"
                  onClose={() => setOpenDropdown(false)}
                  value={dropValue}
                  onSelect={(val) => {
                    console.log(val);
                    setDropValue(guestListDropDown[val]);
                    handleClick(val);
                    // setSelectedTab(val);
                    // setPage(0);
                    // setPhotosList([]);
                    // setCheck([]);
                    // setSelectedId([]);
                    // setSelectAll(false);
                  }}>
                  <DropdownMenuGroup hideBottomDivider>
                    {Object.entries(guestListDropDown).map(([value, label]) => (
                      <DropdownMenuItem
                        key={value}
                        value={value}
                        label={label}
                      />
                    ))}
                  </DropdownMenuGroup>
                </DropdownMenu>
              </div>
            </div>
          </Container>
        </Container>
        <Box
          sx={{
            width: "100%",
            mt: "12px",
          }}>
          {(Object.keys(filterOptions).length > 0 ||
            (PROFILE_PICTURE_BACKEND_ENABLED &&
              profilePictureFilter !== null)) && (
              <Box my={2}>
                <Container
                  fullWidth
                  verticalAlign="center"
                  horizontalAlign="space-between">
                  <Container
                    verticalAlign="center"
                    gap={16}
                    style={{ flexWrap: "wrap" }}>
                    {PROFILE_PICTURE_BACKEND_ENABLED &&
                      profilePictureFilter !== null && (
                        <Chip
                          key={`profile-picture-${profilePictureFilter}`}
                          label={
                            <Text
                              text={
                                profilePictureFilter
                                  ? "Without profile picture"
                                  : "With profile picture"
                              }
                              appearance="body-s"
                            />
                          }
                          onDelete={handleDeleteProfilePictureChip}
                        />
                      )}
                    {Object.entries(filterOptions).map(([id, values]) =>
                      values.map((label) => (
                        <Chip
                          key={`${id}-${label}`}
                          label={<Text text={label} appearance="body-s" />}
                          onDelete={() => handleDeleteChip(id, label)}
                        />
                      )),
                    )}
                  </Container>
                  <Button
                    label="Clear Filter"
                    iconLeft="IcClose"
                    size="small"
                    kind="secondary"
                    onClick={handleClearFilters}
                  />
                </Container>
              </Box>
            )}
          <Divider pad="xx-small" padPosition="vertical" />
        </Box>
      </Container>

      {guestList?.length > 0 && (
        <>
          {gridView && (
            <Box
              cols={3}
              rowHeight={240}
              sx={{
                display: "grid",
                gridTemplateColumns: `repeat(auto-fit, minmax(284px, ${guestList.length > 2 ? "1fr" : "350px"
                  }))`,
                gap: "60px",
                width: "100%",
                m: "32px 0 32px",
              }}>
              {guestList.map((guest, i) => {
                if (
                  guest?.registerStatus == "REGISTERED" &&
                  !guest?.isBlocked
                ) {
                  return (
                    <div
                      ref={i + 1 == guestList.length ? lastElementRef : null}
                      key={i}>
                      <RegisteredGuests
                        guest={guest}
                        loadContactInfo={loadDrawerContactInfo}
                        contactInfo={userContactInfo}
                        isContactInfoLoading={contactInfoIsLoading}
                        setContactInfoModalClose={(userId) => {
                          getContactInfoApi(
                            {
                              url: `event-attendee/${eventId}/view-contact/${userId}`,
                            },
                            () => { },
                            (data) => {
                              setUserContactInfo(data?.data);
                            },
                          );
                          setContactInfoModalClose(false);
                        }}
                        action={actionHandler}
                        actionHandleLoading={actionHandleLoading}
                        setDenyModalClose={() => {
                          setEditGuestData(guest);
                          setDenyModalClose(false);
                        }}
                        setBlockModalClose={() => {
                          setEditGuestData(guest);
                          setBlockModalClose(false);
                        }}
                        setIsEditGuestModalClose={() => {
                          setEditGuestData(guest);
                          setIsEditGuestModalClose(false);
                        }}
                        setIsFaceModalClose={() => {
                          setEditGuestData(guest);
                          // setIsFaceModalClose(false);
                          navigate(
                            `/home/events/guests/${eventId}/guest-cluster-list/${guest?.userId}`,
                            {
                              state: {
                                firstName: guest?.firstName,
                                lastName: guest?.lastName,
                                indexedProfileThumbnail:
                                  guest?.profilePictureThumbnailUrl,
                                indexedProfilePic: guest?.profilePictureUrl,
                                secondaryProfilesCount:
                                  guest?.secondaryProfilesCount,
                              },
                            },
                          );
                        }}
                        hasCustomField={hasCustomField}
                        customFields={customFields}
                        onReminderClick={
                          PROFILE_PICTURE_BACKEND_ENABLED
                            ? handleReminderCtaClick
                            : undefined
                        }
                        isReminderLoading={
                          PROFILE_PICTURE_BACKEND_ENABLED &&
                          reminderLoadingGuestId === guest?.id
                        }
                        showQuickTiming={guestType === "REGISTERED"}
                      />
                    </div>
                  );
                }
                if (guest?.registerStatus == null && !guest?.isBlocked) {
                  return (
                    <div
                      ref={i + 1 == guestList.length ? lastElementRef : null}
                      key={i}>
                      <InvitedGuests
                        guest={guest}
                        loadContactInfo={loadDrawerContactInfo}
                        contactInfo={userContactInfo}
                        isContactInfoLoading={contactInfoIsLoading}
                        setContactInfoModalClose={(userId) => {
                          getContactInfoApi(
                            {
                              url: `event-attendee/${eventId}/view-contact/${userId}`,
                            },
                            () => { },
                            (data) => {
                              setUserContactInfo(data?.data);
                              console.log(decryptUrl(data?.data?.email));
                              console.log(decryptUrl(data?.data?.phoneNumber));
                            },
                          );
                          setContactInfoModalClose(false);
                        }}
                        setBlockModalClose={() => {
                          setEditGuestData(guest);
                          setBlockModalClose(false);
                        }}
                        setIsEditGuestModalClose={() => {
                          setEditGuestData(guest);
                          setIsEditGuestModalClose(false);
                        }}
                        setIsFaceModalClose={() => {
                          setEditGuestData(guest);
                          // setIsFaceModalClose(false);
                          navigate(
                            `/home/events/guests/${eventId}/guest-cluster-list/${guest?.userId}`,
                            {
                              state: {
                                firstName: guest?.firstName,
                                lastName: guest?.lastName,
                                indexedProfileThumbnail:
                                  guest?.profilePictureThumbnailUrl,
                                indexedProfilePic: guest?.profilePictureUrl,
                                secondaryProfilesCount:
                                  guest?.secondaryProfilesCount,
                              },
                            },
                          );
                        }}
                        setSecondaryProfileModalClose={(id) => {
                          getSecondaryProfiles(
                            {
                              url: `face/profile/cluster?eventId=${eventId}&userId=${id}`,
                              base: "MEDIA",
                            },
                            null,
                            (data) => {
                              setSecondaryProfileList(data?.data);
                            },
                            (err, data) => {
                              Notifications.toast.error({
                                id: "get-secondary-profile-for-user",
                                title: data?.message,
                              });
                            },
                          );
                          setSecondaryProfileModalClose(false);
                        }}
                        hasCustomField={hasCustomField}
                        customFields={customFields}
                        onReminderClick={
                          PROFILE_PICTURE_BACKEND_ENABLED
                            ? handleReminderCtaClick
                            : undefined
                        }
                        isReminderLoading={
                          PROFILE_PICTURE_BACKEND_ENABLED &&
                          reminderLoadingGuestId === guest?.id
                        }
                        showQuickTiming={guestType === "NULL"}
                      />
                    </div>
                  );
                }
                if (guest?.registerStatus == "APPROVED" && !guest?.isBlocked) {
                  return (
                    <div
                      ref={i + 1 == guestList.length ? lastElementRef : null}
                      key={i}>
                      <ApprovedGuests
                        guest={guest}
                        loadContactInfo={loadDrawerContactInfo}
                        contactInfo={userContactInfo}
                        isContactInfoLoading={contactInfoIsLoading}
                        setContactInfoModalClose={(userId) => {
                          getContactInfoApi(
                            {
                              url: `event-attendee/${eventId}/view-contact/${userId}`,
                            },
                            () => { },
                            (data) => {
                              setUserContactInfo(data?.data);
                            },
                          );
                          setContactInfoModalClose(false);
                        }}
                        setBlockModalClose={() => {
                          setEditGuestData(guest);
                          setBlockModalClose(false);
                        }}
                        setIsEditGuestModalClose={() => {
                          setEditGuestData(guest);
                          setIsEditGuestModalClose(false);
                        }}
                        setIsFaceModalClose={() => {
                          setEditGuestData(guest);
                          // setIsFaceModalClose(false);
                          navigate(
                            `/home/events/guests/${eventId}/guest-cluster-list/${guest?.userId}`,
                            {
                              state: {
                                firstName: guest?.firstName,
                                lastName: guest?.lastName,
                                indexedProfileThumbnail:
                                  guest?.profilePictureThumbnailUrl,
                                indexedProfilePic: guest?.profilePictureUrl,
                                secondaryProfilesCount:
                                  guest?.secondaryProfilesCount,
                              },
                            },
                          );
                        }}
                        hasCustomField={hasCustomField}
                        customFields={customFields}
                        onReminderClick={
                          PROFILE_PICTURE_BACKEND_ENABLED
                            ? handleReminderCtaClick
                            : undefined
                        }
                        isReminderLoading={
                          PROFILE_PICTURE_BACKEND_ENABLED &&
                          reminderLoadingGuestId === guest?.id
                        }
                      />
                    </div>
                  );
                }
                if (guest?.registerStatus == "DENIED" && !guest?.isBlocked) {
                  return (
                    <div
                      ref={i + 1 == guestList.length ? lastElementRef : null}
                      key={i}>
                      <DeniedGuests
                        guest={guest}
                        loadContactInfo={loadDrawerContactInfo}
                        contactInfo={userContactInfo}
                        isContactInfoLoading={contactInfoIsLoading}
                        setContactInfoModalClose={(userId) => {
                          getContactInfoApi(
                            {
                              url: `event-attendee/${eventId}/view-contact/${userId}`,
                            },
                            () => { },
                            (data) => {
                              setUserContactInfo(data?.data);
                            },
                          );
                          setContactInfoModalClose(false);
                        }}
                        action={actionHandler}
                        actionHandleLoading={actionHandleLoading}
                        setIsFaceModalClose={() => {
                          setEditGuestData(guest);
                          // setIsFaceModalClose(false);
                          navigate(
                            `/home/events/guests/${eventId}/guest-cluster-list/${guest?.userId}`,
                            {
                              state: {
                                firstName: guest?.firstName,
                                lastName: guest?.lastName,
                                indexedProfileThumbnail:
                                  guest?.profilePictureThumbnailUrl,
                                indexedProfilePic: guest?.profilePictureUrl,
                                secondaryProfilesCount:
                                  guest?.secondaryProfilesCount,
                              },
                            },
                          );
                        }}
                        hasCustomField={hasCustomField}
                        customFields={customFields}
                        onReminderClick={
                          PROFILE_PICTURE_BACKEND_ENABLED
                            ? handleReminderCtaClick
                            : undefined
                        }
                        isReminderLoading={
                          PROFILE_PICTURE_BACKEND_ENABLED &&
                          reminderLoadingGuestId === guest?.id
                        }
                      />
                    </div>
                  );
                }
                if (guest?.isBlocked) {
                  return (
                    <div
                      ref={i + 1 == guestList.length ? lastElementRef : null}
                      key={i}>
                      <BlockedGuests
                        guest={guest}
                        loadContactInfo={loadDrawerContactInfo}
                        contactInfo={userContactInfo}
                        isContactInfoLoading={contactInfoIsLoading}
                        setContactInfoModalClose={(userId) => {
                          getContactInfoApi(
                            {
                              url: `event-attendee/${eventId}/view-contact/${userId}`,
                            },
                            () => { },
                            (data) => {
                              setUserContactInfo(data?.data);
                            },
                          );
                          setContactInfoModalClose(false);
                        }}
                        restoreAction={restoreHandler}
                        restoreHandleLoading={restoreHandleLoading}
                        setIsFaceModalClose={() => {
                          setEditGuestData(guest);
                          // setIsFaceModalClose(false);
                          navigate(
                            `/home/events/guests/${eventId}/guest-cluster-list/${guest?.userId}`,
                            {
                              state: {
                                firstName: guest?.firstName,
                                lastName: guest?.lastName,
                                indexedProfileThumbnail:
                                  guest?.profilePictureThumbnailUrl,
                                indexedProfilePic: guest?.profilePictureUrl,
                                secondaryProfilesCount:
                                  guest?.secondaryProfilesCount,
                              },
                            },
                          );
                        }}
                        hasCustomField={hasCustomField}
                        customFields={customFields}
                        onReminderClick={
                          PROFILE_PICTURE_BACKEND_ENABLED
                            ? handleReminderCtaClick
                            : undefined
                        }
                        isReminderLoading={
                          PROFILE_PICTURE_BACKEND_ENABLED &&
                          reminderLoadingGuestId === guest?.id
                        }
                      />
                    </div>
                  );
                }
              })}
            </Box>
          )}
          {!gridView && (
            <NewGuestList
              key={`${guestType}-${searchValue}-${sortConfig?.sortBy}-${sortConfig?.direction}-${PROFILE_PICTURE_BACKEND_ENABLED ? profilePictureFilter : "profile-picture-filter-disabled"}-${JSON.stringify(filterOptions)}`}
              searchValue={searchValue}
              columns={guestListCoulmn[guestType]}
              type={apiGuestListType[guestType]}
              guestType={guestType}
              setGuestList={setGuestList}
              tableReset={tableReset}
              refetchTable={refetchTable}
              customFields={customFields}
              ref={guestListRef}
              filterOptions={filterOptions}
              profilePictureFilter={
                PROFILE_PICTURE_BACKEND_ENABLED ? profilePictureFilter : null
              }
              propSortConfig={sortConfig}
              propSetSortConfig={setSortConfig}
            />
          )}
        </>
      )}
      {guestList?.length == 0 && !loading && (
        <Box mt={7}>
          <EmptyState
            title=""
            subtitle={
              searchValue ||
                (typeof filterOptions === "object" &&
                  filterOptions !== null &&
                  Object.keys(filterOptions).length > 0) ||
                (PROFILE_PICTURE_BACKEND_ENABLED &&
                  profilePictureFilter !== null)
                ? "Try removing or adjusting your filters to see more results."
                : handleGuestTypeEmptyState(value)
            }
            action={false}
          />
        </Box>
      )}
      <Container fullWidth horizontalAlign="center">
        {(guestDataLoading || loading) && gridView && page === 0 && (
          <Loader containerProps={{ style: { marginTop: "16px" } }} />
        )}
      </Container>
      <Container fullWidth horizontalAlign="center">
        {(guestDataLoading || loading) && gridView && page !== 0 && (
          <Loader
            size="small"
            containerProps={{ style: { marginTop: "16px" } }}
          />
        )}
      </Container>

      {PROFILE_PICTURE_BACKEND_ENABLED && (
        <JdsModal
          size="m"
          kind="custom"
          close={isProfileReminderModalClose}
          onClose={() => {
            setProfileReminderModalClose(true);
          }}
          headerProps={{ divider: "false" }}>
          <div>
            <Stack gap={0.5}>
              <Text
                text={`Send profile picture reminder to guests`}
                appearance="heading_xs"
              />
              <Text
                text={`Profile picture is required to group and cluster guest photos.`}
                appearance="body_s"
                color="primary-grey-80"
              />
            </Stack>
            <Stack direction={"row"} justifyContent={"end"} gap={"12px"} mt={2}>
              <ActionButton
                label="Cancel"
                kind="secondary"
                size="medium"
                onClick={() => {
                  setProfileReminderModalClose(true);
                }}
                appearance=""
              />
              <ActionButton
                label="Send"
                kind="primary"
                size="medium"
                onClick={() => {
                  handleBulkReminder();
                  setProfileReminderModalClose(true);
                }}
                appearance=""
                isLoading={sendBlukReminderApiLoading}
              />
            </Stack>
          </div>
        </JdsModal>
      )}

      <JdsModal
        header={"Contact Information"}
        kind="custom"
        close={isContactInfoModalClose}
        onClose={() => setContactInfoModalClose(true)}>
        {!isContactInfoModalClose &&
          (contactInfoIsLoading ? (
            <Skeleton shape="paragraph" width="200px" animated />
          ) : (
            <Container direction="column" gap={16}>
              {userContactInfo?.email && (
                <Container gap={6} verticalAlign="center">
                  <Icon ic={"IcMail"} color="primary_grey_80" size="large" />
                  <Text
                    text={decryptUrl(userContactInfo?.email)}
                    appearance="body-m"
                  />
                </Container>
              )}
              <Container gap={6} verticalAlign="center">
                <Icon ic={"IcCall"} color="primary_grey_80" size="large" />
                <Text
                  text={
                    userContactInfo?.countryCode +
                    "  " +
                    decryptUrl(userContactInfo?.phoneNumber)
                  }
                  appearance="body-m"
                />
              </Container>
            </Container>
          ))}
      </JdsModal>

      <JdsModal
        header={"Registered Information"}
        kind="custom"
        close={isRegisteredInfoModalClose}
        onClose={() => setRegisteredInfoModalClose(true)}>
        {!isRegisteredInfoModalClose && (
          <CustomField
            hasCustomField={hasCustomField}
            customFields={customFields}
            guest={editGuestData}
          />
        )}
      </JdsModal>

      <JdsModal
        header="Invite Guests"
        size="m"
        kind="custom"
        close={isAddGuestModalClose}
        headerProps={{
          divider: "false",
        }}
        onClose={() => {
          setAddGuestModalClose(true);
        }}>
        {!isAddGuestModalClose && (
          <div>
            <Box className="registration-link-container" pt={2} pb={1}>
              <Container gap={16}>
                <Button
                  label="Download QR code"
                  kind="secondary"
                  size="small"
                  onClick={() =>
                    downloadQrImage(eventDetails?.qrCodeImage, eventDetails)
                  }
                />
                <Button
                  label="Copy link"
                  kind="secondary"
                  size="small"
                  onClick={() => {
                    navigator.clipboard
                      .writeText(
                        `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventDetails?.id}`,
                      )
                      .then(() => {
                        Notifications.toast.success({
                          id: "copy-link",
                          title: "Link copied to clipboard",
                        });
                      })
                      .catch((err) => { });
                  }}
                />
                {/* <Button label="Send on whatsapp" kind="secondary" size="small" onClick={() => {
                  const message = `You’re Invited!  
We’re excited to invite you to our upcoming event ${eventDetails?.name} @ ${eventDetails?.locationName}.  
Please register using the link below to confirm your spot:  

[Event Link] ${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventDetails?.id} 

By registering, you’ll also get exclusive access to event photos, presentations, and special content on JioCloud's photoshare.  

We look forward to seeing you there!`
                  const whatsappUrl = createWhatsAppLink(message);
                  window.open(whatsappUrl, "_blank"); // opens WhatsApp in new tab/app
                }
                } /> */}
              </Container>
            </Box>
            <Divider
              ariaHidden="Divider"
              label="or"
              orientation="horizontal"
              pad="small"
              padPosition="vertical"
              variant="default"
            />
            <Container
              fullWidth
              horizontalAlign="center"
              style={{ paddingTop: "20px", paddingBottom: "28px" }}>
              <Text
                text="Invite using phone & email"
                appearance="body-m-bold"
                color="primary-grey-80"
              />
            </Container>
            <InviteGuestForm
              onSuccess={() => {
                if (guestType !== "NULL") {
                  setGuestList([]);
                  setSearchValue("");
                  setGuestType("NULL");
                }
                if (gridView) {
                  if (page !== 0) {
                    setPage(0);
                  } else {
                    getGuestHandler(apiGuestListType["NULL"]);
                  }
                } else {
                  guestListRef.current.tableResetFun();
                }
                setAddGuestModalClose(true);
              }}
            // customFields={customFields}
            />
          </div>
        )}
      </JdsModal>

      <JdsModal
        header={"Approve"}
        kind="custom"
        close={isApproveModalClose}
        onClose={() => setIsApproveModalClose(true)}>
        {!isApproveModalClose && (
          <ApproveRegisteration
            onSuccess={() => getGuestHandler(apiGuestListType[0])}
          />
        )}
      </JdsModal>

      {/* Deny User Model  */}
      <JdsModal
        size="m"
        header="Are you sure you want to deny this user?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDenyModalClose}
        onClose={() => setDenyModalClose(true)}
        onPrimaryClick={() => {
          actionHandler("3", editGuestData?.id);
        }}
        onSecondaryClick={() => setDenyModalClose(true)}
        primaryCtaDisabled={actionHandleLoading}
      />

      {/* Block User Model  */}
      <JdsModal
        size="m"
        header="Are you sure you want to block this user?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isBlockModalClose}
        onClose={() => setBlockModalClose(true)}
        onPrimaryClick={() => {
          handleBlock(editGuestData?.id);
        }}
        onSecondaryClick={() => setBlockModalClose(true)}
        primaryCtaDisabled={actionHandleLoading}
      />

      <JdsModal
        header={`Edit Guest`}
        kind="custom"
        close={isEditGuestModalClosed}
        onClose={() => setIsEditGuestModalClose(true)}>
        {!isEditGuestModalClosed && (
          <EditGuestForm
            data={{
              ...editGuestData,
              userId: editGuestData?.id,
              profilePic: editGuestData?.profilePictureThumbnailUrl
                ? addParamsURL(editGuestData?.profilePictureThumbnailUrl, {
                  size: "s",
                })
                : null,
              role: "GUEST",
              profileFile: editGuestData?.profileFile,
            }}
            onSuccess={(guest, update) => {
              if (gridView) {
                if (update) {
                  setGuestList((pre) => {
                    const updateData = pre.map((item) => {
                      if (item.id == guest.id) {
                        return {
                          ...item,
                          firstName: guest.firstName,
                          lastName: guest.lastName,
                          email: guest?.email,
                          profileFile: guest?.profilePicture,
                        };
                      } else {
                        return item;
                      }
                    });
                    return updateData;
                  });
                } else {
                  if (guestType === "ALL") {
                    setGuestList((pre) => {
                      const updateData = pre.map((item) => {
                        if (item.id === guest.id) {
                          return {
                            ...item,
                            isBlocked: true,
                          };
                        } else {
                          return item;
                        }
                      });
                      return updateData;
                    });
                  } else {
                    setGuestList((pre) => {
                      const updateData = pre.filter(
                        (item) => item.id !== guest.id,
                      );
                      return updateData;
                    });
                    setRemoveCount((pre) => pre + 1);
                  }
                }
              } else {
                if (update) {
                  guestListRef.current.tableRefetchFun();
                  // setRefetchTable((pre) => !pre);
                } else {
                  guestListRef.current.tableResetFun();
                  // setTableReset((pre) => !pre);
                  setRemoveCount((pre) => pre + 1);
                }
              }
            }}
            closeModal={() => setIsEditGuestModalClose(true)}
          // customFields={customFields}
          />
        )}
      </JdsModal>

      <JdsModal
        header={`${editGuestData?.firstName + " " + editGuestData?.lastName || "Unnamed"
          }`}
        kind="custom"
        close={isFaceModalClosed}
        onClose={() => {
          setIsFaceModalClose(true);
          // window.location.reload();
        }}>
        {!isFaceModalClosed && <GuestListModal data={editGuestData} />}
      </JdsModal>

      {/* Secondary Profiles Modal */}
      <JdsModal
        header={"Secondary Profiles"}
        kind="custom"
        close={isSecondaryProfileModalClose}
        onClose={() => setSecondaryProfileModalClose(true)}>
        {!isSecondaryProfileModalClose && (
          <Stack direction={"row"} justifyContent={"center"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={3}>
              {secondaryProfilesLoading ? (
                <Loader size="medium" />
              ) : secondaryProfileList.length > 0 ? (
                secondaryProfileList.map((data, i) => {
                  return (
                    <AvatarV2
                      key={i}
                      size="large"
                      avatarKind={data?.image ? "image" : "icon"}
                      image={data?.image}
                      onClick={() => {
                        console.log("ck");
                      }}
                    />
                  );
                })
              ) : (
                <EmptyState
                  title="No secondary profile found for this user."
                  action={false}
                />
              )}
            </Stack>
          </Stack>
        )}
      </JdsModal>
    </>
  );
};

export default NewGuests;

const CustomField = ({ guest, hasCustomField = false, customFields = {} }) => {
  const customFieldsShow = (customFields, field) => {
    if (
      customFields?.[field.id]?.type === "text" ||
      customFields?.[field.id]?.type === "dropdown" ||
      customFields?.[field.id]?.type === "radio" ||
      customFields?.[field.id]?.type === "date" ||
      customFields?.[field.id]?.type === "paragraph"
    ) {
      return (
        <>
          <Tooltip
            label={customFields?.[field.id]?.questionName}
            position="bottom">
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
              }}>
              <b>{customFields?.[field.id]?.questionName}:</b>
            </p>
          </Tooltip>
          <Tooltip
            label={customFields?.[field.id]?.questionName + ": " + field.value}
            position="bottom">
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
              }}>
              {field.value}
            </p>
          </Tooltip>
        </>
      );
    }
    if (customFields?.[field.id]?.type === "consent") {
      return (
        <>
          <Tooltip
            label={customFields?.[field.id]?.questionName}
            position="bottom">
            <Container gap={8}>
              <InputCheckbox checked={field.value} disabled />
              <p
                style={{
                  whiteSpace: "nowrap",
                  maxWidth: "220px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                {customFields?.[field.id]?.questionName}
              </p>
            </Container>
          </Tooltip>
        </>
      );
    }
    if (customFields?.[field.id]?.type === "checkbox") {
      return (
        <>
          <Tooltip
            label={customFields?.[field.id]?.questionName}
            position="bottom">
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
              }}>
              <b>{customFields?.[field.id]?.questionName}:</b>
            </p>
          </Tooltip>
          <Tooltip
            label={
              customFields?.[field.id]?.questionName +
              ": " +
              field.value.map((val, index) =>
                index + 1 !== field.value.length ? val + "" : val,
              )
            }
            position="bottom">
            <p
              style={{
                whiteSpace: "nowrap",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}>
              {field.value.map((val, index) =>
                index + 1 !== field.value.length ? val + ", " : val + ".",
              )}
            </p>
          </Tooltip>
        </>
      );
    }
  };

  return (
    <>
      {hasCustomField && (
        <>
          {guest?.customField?.length > 0 && (
            <div
              style={{
                paddingBottom: "10px",
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                width: "100%",
              }}>
              {guest?.customField?.map((item) => {
                return customFieldsShow(customFields, item);
              })}
            </div>
          )}
          {!guest?.customField && (
            <div
              fullWidth
              style={{
                paddingBlock: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <p>Yet to register</p>
            </div>
          )}
        </>
      )}
    </>
  );
};

const FilterBtn = (props) => (
  <Tooltip label={`Filter`} position="bottom">
    <Icon ic={"IcFilterMultiple"} onClick={() => { }} {...props} />
  </Tooltip>
);

const FilterComponent = memo(
  ({
    customFieldAnalytics = [],
    filterOptions = {},
    setFilterOptions = () => { },
    setPage = () => { },
    profilePictureFilter = null,
    setProfilePictureFilter = () => { },

    close = () => { },
  }) => {
    const [selectedFilterOption, setSelectedFilterOption] = useState({});
    const [selectedProfilePictureFilter, setSelectedProfilePictureFilter] =
      useState(profilePictureFilter);
    useEffect(() => {
      setSelectedFilterOption(filterOptions);
      setSelectedProfilePictureFilter(profilePictureFilter);
    }, [filterOptions, profilePictureFilter]);
    return (
      <div>
        <p className="cus-fil-pad cus-head">Filter</p>
        <p className="cus-fil-bor"></p>
        <div className="custom-filter-container">
          <div>
            <div className="cus-que">Profile picture</div>
            <div
              className="cus-fil-option"
              onClick={() => {
                setSelectedProfilePictureFilter((prev) =>
                  prev === false ? null : false,
                );
              }}>
              <div>
                <InputRadio
                  name="profile-picture-filter"
                  checked={selectedProfilePictureFilter === false}
                  size="small"
                />
              </div>
              <p className="word-wrap">With profile picture</p>
            </div>
            <div
              className="cus-fil-option"
              onClick={() => {
                setSelectedProfilePictureFilter((prev) =>
                  prev === true ? null : true,
                );
              }}>
              <div>
                <InputRadio
                  name="profile-picture-filter"
                  checked={selectedProfilePictureFilter === true}
                  size="small"
                />
              </div>
              <p className="word-wrap">Without profile picture</p>
            </div>
          </div>
          {customFieldAnalytics.length > 0 && <p className="cus-fil-bor"></p>}
          {customFieldAnalytics.map((customField, index) => {
            return (
              <>
                <div>
                  <div
                    className="cus-que"
                    title={customField?.questionName}
                    onClick={() => {
                      const fieldId = customField.id;
                      let isSelected =
                        selectedFilterOption?.[fieldId]?.length !==
                        customField?.answerStats?.length;

                      const updatedAnswers = isSelected
                        ? customField?.answerStats?.map(
                          (ans, index) => ans?.answer,
                        )
                        : [];
                      console.log(updatedAnswers, isSelected);
                      setSelectedFilterOption((prev) => {
                        if (updatedAnswers.length > 0) {
                          return {
                            ...prev,
                            [fieldId]: updatedAnswers,
                          };
                        } else {
                          const { [fieldId]: _, ...rest } = prev;
                          return rest;
                        }
                      });
                    }}>
                    <InputCheckbox
                      size="small"
                      checked={
                        selectedFilterOption?.[customField?.id]?.length ===
                        customField?.answerStats?.length ?? false
                      }
                      indeterminate={
                        selectedFilterOption?.[customField?.id]?.length > 0 &&
                        selectedFilterOption?.[customField?.id]?.length !==
                        customField?.answerStats?.length
                      }
                    />
                    <p className="word-wrap">{customField?.questionName}</p>

                    {/* <Icon ic={"IcCloseRemove"} onClick={() => {}} /> */}
                  </div>

                  {customField?.answerStats?.map((ans, index) => {
                    return (
                      <div
                        className="cus-fil-option"
                        title={`${ans?.answer}`}
                        onClick={() => {
                          const fieldId = customField.id;
                          const currentAnswers =
                            selectedFilterOption?.[fieldId] || [];
                          const isSelected = currentAnswers.includes(
                            ans.answer,
                          );

                          const updatedAnswers = isSelected
                            ? currentAnswers.filter((a) => a !== ans.answer) // remove
                            : [...currentAnswers, ans.answer]; // add

                          // setSelectedFilterOption((prev) => ({
                          //   ...prev,
                          //   [fieldId]: updatedAnswers,
                          // }));
                          setSelectedFilterOption((prev) => {
                            if (updatedAnswers.length > 0) {
                              return {
                                ...prev,
                                [fieldId]: updatedAnswers,
                              };
                            } else {
                              const { [fieldId]: _, ...rest } = prev;
                              return rest;
                            }
                          });
                        }}>
                        <InputCheckbox
                          size="small"
                          checked={
                            selectedFilterOption?.[customField?.id]?.includes(
                              ans?.answer,
                            ) ?? false
                          }
                        />
                        <p className="word-wrap">{ans?.answer}</p>
                        {/* <p className="cus-fil-count">({ans?.count})</p> */}
                      </div>
                    );
                  })}
                </div>
                {index !== customFieldAnalytics.length - 1 && (
                  <p className="cus-fil-bor"></p>
                )}
              </>
            );
          })}
        </div>
        <p className="cus-fil-bor"></p>
        <div className="cus-fil-pad">
          <Button
            fullWidth
            kind="primary"
            size="small"
            label="Apply Filter"
            onClick={() => {
              setFilterOptions(selectedFilterOption);
              setProfilePictureFilter(selectedProfilePictureFilter);
              setPage(0);
              close();
            }}
          />
        </div>
      </div>
    );
  },
);

const SortBtn = (props) => (
  <Tooltip label={`Sort`} position="bottom">
    <Icon ic={"IcSort"} onClick={() => { }} {...props} />
  </Tooltip>
);

const SortComponent = memo(
  ({ sortConfig = {}, setSortConfig = () => { }, setPage = () => { } }) => {
    return (
      <div>
        <div>
          <p className="cus-fil-pad cus-head">Sort By</p>
          <div className="custom-filter-container">
            <div>
              <div
                className="cus-fil-option"
                title={`Date`}
                onClick={() => {
                  if (sortConfig?.sortBy !== "createdAt") {
                    setSortConfig((pre) => ({ ...pre, sortBy: "createdAt" }));
                    setPage(0);
                  }
                }}>
                <InputRadio
                  size="small"
                  checked={sortConfig?.sortBy === "createdAt"}
                />
                <p className="word-wrap">Date</p>
              </div>
              <div
                className="cus-fil-option"
                title={`Name`}
                onClick={() => {
                  if (sortConfig?.sortBy !== "fullName") {
                    setSortConfig((pre) => ({ ...pre, sortBy: "fullName" }));
                    setPage(0);
                  }
                }}>
                <InputRadio
                  size="small"
                  checked={sortConfig?.sortBy === "fullName"}
                />
                <p className="word-wrap">Name</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p className="cus-fil-bor"></p>
          <p className="cus-fil-pad cus-head">Sort Order</p>
          <div className="custom-filter-container">
            {sortConfig?.sortBy === "createdAt" && (
              <div>
                <div
                  className="cus-fil-option"
                  onClick={() => {
                    if (sortConfig?.direction !== "ASC") {
                      setSortConfig((pre) => ({ ...pre, direction: "ASC" }));
                      setPage(0);
                    }
                  }}>
                  <InputRadio
                    size="small"
                    checked={sortConfig?.direction === "ASC"}
                  />
                  <p className="word-wrap">Oldest on top</p>
                </div>
                <div
                  className="cus-fil-option"
                  onClick={() => {
                    if (sortConfig?.direction !== "DESC") {
                      setSortConfig((pre) => ({ ...pre, direction: "DESC" }));
                      setPage(0);
                    }
                  }}>
                  <InputRadio
                    size="small"
                    checked={sortConfig?.direction === "DESC"}
                  />
                  <p className="word-wrap">Newest on top</p>
                </div>
              </div>
            )}
            {sortConfig?.sortBy === "fullName" && (
              <div>
                <div
                  className="cus-fil-option"
                  onClick={() => {
                    if (sortConfig?.direction !== "ASC") {
                      setSortConfig((pre) => ({ ...pre, direction: "ASC" }));
                      setPage(0);
                    }
                  }}>
                  <InputRadio
                    size="small"
                    checked={sortConfig?.direction === "ASC"}
                  />
                  <p className="word-wrap">A to Z</p>
                </div>
                <div
                  className="cus-fil-option"
                  onClick={() => {
                    if (sortConfig?.direction !== "DESC") {
                      setSortConfig((pre) => ({ ...pre, direction: "DESC" }));
                      setPage(0);
                    }
                  }}>
                  <InputRadio
                    size="small"
                    checked={sortConfig?.direction === "DESC"}
                  />
                  <p className="word-wrap">Z to A</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);
